import {SlideStateVo} from '../../common/shared/api/nicolas/vo/enums/SlideStateVo.enum';
import {SaleState} from '../generated/types';

export function createSaleState(slideTypeVo: SlideStateVo): SaleState {
  return SlideTypeToSaleStateMap[slideTypeVo] || SaleState.Unknown;
}

const SlideTypeToSaleStateMap: {
  [key in SlideStateVo]: SaleState;
} = {
  [SlideStateVo.ST61]: SaleState.Ing,
  [SlideStateVo.ST62]: SaleState.Stop,
  [SlideStateVo.ST64]: SaleState.Stop,
  // 나머진 모두 Unknown
  [SlideStateVo.ST22]: SaleState.Unknown,
  [SlideStateVo.ST21]: SaleState.Unknown,
  [SlideStateVo.ST23]: SaleState.Unknown,
  [SlideStateVo.ST30]: SaleState.Unknown,
  [SlideStateVo.ST40]: SaleState.Unknown,
  [SlideStateVo.ST41]: SaleState.Unknown,
  [SlideStateVo.ST45]: SaleState.Unknown,
  [SlideStateVo.ST50]: SaleState.Unknown,
  [SlideStateVo.ST51]: SaleState.Unknown,
  [SlideStateVo.ST52]: SaleState.Unknown,
  [SlideStateVo.ST53]: SaleState.Unknown,
  [SlideStateVo.ST54]: SaleState.Unknown,
  [SlideStateVo.ST63]: SaleState.Unknown,
  [SlideStateVo.ST99]: SaleState.Unknown,
};
